export const userQueryKeys = {
  all: () => ['user'],
  configurations: (type: number) => [
    ...userQueryKeys.all(),
    'configurations',
    type,
  ],
  organisations: () => [...userQueryKeys.all(), 'organisations'],
  notifications: (query?: object) => [
    ...userQueryKeys.all(),
    'notifications',
    query,
  ],
};

export const configurationQueryKeys = {
  all: () => ['configurations'],
  templates: (level: string) => [...configurationQueryKeys.all(), '2', level],
};

export const applianceQueryKeys = {
  all: () => ['appliances'],
  superAdminAll: () => ['superadmin', ...applianceQueryKeys.all()],
  types: () => [...applianceQueryKeys.all(), 'types'],
  superAdminTypes: () => [
    ...applianceQueryKeys.superAdminAll(),
    ...applianceQueryKeys.types(),
  ],
  manufacturers: (typeId?: string) => [
    ...applianceQueryKeys.all(),
    'manufacturers',
    typeId,
  ],
  superAdminManufacturers: (typeId?: string) => [
    ...applianceQueryKeys.superAdminAll(),
    'manufacturers',
    typeId,
  ],
  models: (manufacturerId?: string) => [
    ...applianceQueryKeys.all(),
    'models',
    manufacturerId,
  ],
  superAdminModels: (manufacturerId?: string) => [
    ...applianceQueryKeys.superAdminAll(),
    'models',
    manufacturerId,
  ],
};

export const planetDeviceQueryKeys = {
  all: () => ['planetdevice'],
  allWithGateway: () => [...planetDeviceQueryKeys.all(), 'withGateway'],
  single: (id: string) => [...planetDeviceQueryKeys.allWithGateway(), id],
};

export const actionQueryKeys = {
  byModel: (hardwareModelId?: string) =>
    hardwareModelId ? ['actions', hardwareModelId] : ['actions'],
  superAdminAll: () => ['superadmin', 'actions'],
  create: () => [...actionQueryKeys.superAdminAll(), 'create'],
  update: () => [...actionQueryKeys.superAdminAll(), 'update'],
  delete: () => [...actionQueryKeys.superAdminAll(), 'delete'],
};

export const actionProfileQueryKeys = {
  superAdminAll: () => ['superadmin', 'action', 'profile'],
  superAdminByModel: (hardwareModelId: string) => [
    ...actionProfileQueryKeys.superAdminAll(),
    hardwareModelId,
  ],
  create: () => [...actionProfileQueryKeys.superAdminAll(), 'create'],
  update: () => [...actionProfileQueryKeys.superAdminAll(), 'update'],
  delete: () => [...actionProfileQueryKeys.superAdminAll(), 'delete'],
};

export const actionTransformationQueryKeys = {
  superAdminAll: () => ['superadmin', 'action', 'transformation'],
  superAdminByModel: (hardwareModelId: string) => [
    ...actionProfileQueryKeys.superAdminAll(),
    hardwareModelId,
  ],
  create: () => [...actionTransformationQueryKeys.superAdminAll(), 'create'],
  update: () => [...actionTransformationQueryKeys.superAdminAll(), 'update'],
  delete: () => [...actionTransformationQueryKeys.superAdminAll(), 'delete'],
};

export const organisationTariffQueryKeys = {
  all: () => ['organisation', 'tariffs'],
  update: () => [...organisationTariffQueryKeys.all(), 'update'],
};

export const metaDataQueryKeys = {
  all: () => ['metadata'],
};

export const faultQueryKeys = {
  all: () => ['faults'],
  detail: (id: string) => ['faults', id],
  causes: () => ['fault-causes'],
  cause: (id: string) => ['fault-causes', id],
  actions: () => ['fault-actions'],
  action: (id: string) => ['fault-actions', id],
  superAdminDefinitions: () => ['superadmin', 'faults', 'definitions'],
  superAdminCauses: () => ['superadmin', 'faults', 'causes'],
  superAdminActions: () => ['superadmin', 'faults', 'actions'],
};
